import { LoggedInUser } from '../types';

export const checkUserHasAnAddress = (user: LoggedInUser) =>
	user?.houseNo && user?.city && user?.street && user?.postcode;
